import { IUserData } from 'api/ProfileAPI';

export default function getFullNameDisplay(user: IUserData): string | undefined {
  const names = [];
  if (user.first_name != null) names.push(user.first_name);
  if (user.last_name != null) names.push(user.last_name);
  return names.length > 0 ? names.join(' ') : undefined;
}
